import { IVuexState } from './../../../store/store';
import { GetterTree, MutationTree, Commit, ActionTree, ActionContext, Module } from 'vuex';
import { salesReceiptService } from '../api/salesreceipt.api';
import findWithAttr from '@/store/store';
import { Utilities } from '@/features/base/api/utilities';
import moment from 'moment';

export interface ISalesReceiptState {
  salesReceipts: { [storeId: string]: IDayDetails[] };
  dirty: { [storeId: string]: boolean };
}

const state: ISalesReceiptState = {
  salesReceipts: {},
  dirty: {},
};

const getters: GetterTree<ISalesReceiptState, IVuexState> = {
  salesReceipts: (state: ISalesReceiptState) => state.salesReceipts,
  dirty: (state: ISalesReceiptState) => state.dirty,
};

const mutations: MutationTree<ISalesReceiptState> = {
  reset: (state: ISalesReceiptState) => {
    state.salesReceipts = {};
    state.dirty = {};
  },

  set: (state: ISalesReceiptState, { storeId, salesReceipts }: { storeId: string; salesReceipts: IDayDetails[] }) => {
    state.salesReceipts[storeId] = salesReceipts;
  },

  delete: (state: ISalesReceiptState, { storeId, id }: { storeId: string; id: number }) => {
    state.salesReceipts[storeId].splice(id, 1);
  },

  setDirty: (state: ISalesReceiptState, { storeId, dirty }: { storeId: string; dirty: boolean }) => {
    state.dirty[storeId] = dirty;
  },
};

const actions: ActionTree<ISalesReceiptState, IVuexState> = {
  reset: ({ commit }: { commit: Commit }) => {
    commit('reset');
  },

  delete(context: ActionContext<ISalesReceiptState, IVuexState>, { storeId, date }: { storeId: string; date: string }) {
    return salesReceiptService.delete(storeId, moment(date).format('MM-DD-YYYY')).then((response: IApi<number>) => {
      const index = Utilities.findWithAttr(context.state.salesReceipts[storeId], 'date', date);
      context.commit('delete', { storeId, id: index });
    });
  },

  getForStore(context: ActionContext<ISalesReceiptState, IVuexState>, storeId: string) {
    if (!context.state.dirty[storeId] || context.state.dirty[storeId]) {
      return salesReceiptService.forStoreId(storeId).then((response: IApi<IDayDetails[]>) => {
        context.commit('set', { storeId, salesReceipts: response.result });
        context.commit('setDirty', { storeId, dirty: false });
      });
    }
  },
};

const namespaced: boolean = true;

export const salesReceipt: Module<ISalesReceiptState, IVuexState> = { namespaced, state, getters, actions, mutations };
